export default "__VITE_ASSET__BX2zjXUE__"